<div class="position-relative">
  <ng-template #displayWebsite></ng-template>
  <div [hidden]="!showEditor" class="editor-changes" [style.height]="!collpaseEditor ? '50px' : ''"
    [ngClass]="{'rightDirection': editorDirection === 'RIGHT', 'leftDirection': editorDirection === 'LEFT'}">
    <div [style.visibility]="showEditor ? 'visible' : 'hidden'" class="open-editor">
      <div class="top-section" [class.border-bottom]="activeTab.length > 0">
        <div class="component-name" *ngIf="activeTab.length == 0">
          {{ sectionName }}
        </div>

        <!-- Breadcrumb / Sub-view Header -->
        <div class="component-name d-flex align-items-center" *ngIf="activeTab.length > 0">
          <span class="text-muted cursor-pointer" style="font-weight: 500; font-size: 14px; color: #9CA3AF;"
            (click)="gotoStyles()">{{ sectionName }}</span>
          <svg class="mx-1 text-muted" style="width: 14px; height: 14px; stroke-width: 2px; color: #D1D5DB;"
            xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>

          <ng-container *ngIf="activeTab === 'LIST_ITEM'; else simpleTab">
            <span class="text-muted cursor-pointer" style="font-weight: 500; font-size: 14px; color: #9CA3AF;"
              (click)="gotoStyles()">{{ listItemLabel }}</span>
            <svg class="mx-1 text-muted" style="width: 14px; height: 14px; stroke-width: 2px; color: #D1D5DB;"
              xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
            <span style="font-weight: 700; font-size: 14px; color: #111827;">Item {{ listItemIndex + 1 }}</span>
          </ng-container>

          <ng-template #simpleTab>
            <span style="font-weight: 700; font-size: 14px; color: #111827;">{{ tabsHeading[activeTab] || 'Item'
              }}</span>
          </ng-template>
        </div>

        <div class="close-direction-btns d-flex align-items-center gap-2">
          <!-- Direction Toggle -->
          <div class="direction-btn" (click)="changeEditorDirection(editorDirection)" *ngIf="screenWidth > 475">
            <img src="../../../../../../../../assets/images/right-drag.svg" alt=""
              [style.transform]="editorDirection == 'LEFT' ? 'rotate(180deg)' : ''">
          </div>
          <!-- Close Icon -->
          <svg class="cursor-pointer" (click)="dismiss()"
            style="color: #111827; width: 20px; height: 20px; stroke-width: 2px;" xmlns="http://www.w3.org/2000/svg"
            fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </div>
      </div>
      <app-floating-editor [templatePage]="templatePage" [currentPageIndex]="currentPageIndex"></app-floating-editor>
    </div>
  </div>
  <div class="delete-popup">
    <div class="modal" id="deletepopup" tabindex="-1" aria-labelledby="deletepopupLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" style="z-index:1001;">
        <div class="modal-content">
          <div class="top-section-modal">
            <img src="../../../../../../assets/images/invoice/delete-invoice.svg" alt class="delete-img">
            <div class="delete-conformation">
              Are you sure to delete the component?
            </div>
          </div>
          <div class="button-section">
            <div class="left-side">
              <button type="button" class="cancel-button" data-bs-dismiss="modal"
                (click)="cancelSection()">Cancel</button>
            </div>
            <div class="right-side">
              <button type="button" class="delete-button" data-bs-dismiss="modal"
                (click)="DeleteSection()">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>